<template>
  <page>
        <v-row justify="center">
          <div class="d-flex rounded-xl pa-2 icon-wrapper">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  fab
                  small
                  v-bind="attrs"
                  link
                  elevation="0"
                  color="transparent"
                  class="ml-1 mr-2 mb-2 game-toolbar-btn"
                  v-on="on"
                  @click.prevent.stop="showGameModes = !showGameModes">
                <v-icon color="grey darken-1">mdi-monitor-screenshot</v-icon>

              </v-btn>
            </template>
            <span class="assistant">{{
                $t("generics.displayModes")
              }}</span>
          </v-tooltip>
          <div class="gameModes pa-2" v-if="showGameModes">
            <game-display-select @display-changed="displayChanged" />
            <hr class="my-2" />
            <game-screen-select @display-changed="screenChanged" />
          </div>
          <v-btn icon v-if="game.type" @click="$emit('openHelpDialog')" class="pt-1">
            <v-img max-width="30" src="/img/help_wheel.png" class="d-inline-block" />
          </v-btn>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  fab
                  small
                  v-bind="attrs"
                  link
                  elevation="0"
                  color="transparent"
                  class="ml-1 mr-2 mb-2 game-toolbar-btn"
                  v-on="on"
                  @click.prevent.stop="$emit('share')"
              >
                <v-icon color="grey darken-1">mdi-share-variant</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("generics.share") }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  fab
                  small
                  color="transparent"
                  elevation="0"
                  class="ml-2 mb-2 game-toolbar-btn"
                  @click="$emit('delete')"
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon color="grey darken-1">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("generics.delete") }}</span>
          </v-tooltip>
          </div>
        </v-row>

    <row row wrap no-gutters class="mt-3">
      <v-col cols="12" v-if="display === 1">
        <game-preview-view
            :displayView="displayView"
            single="single"
            class="box no-gutters"
        />
      </v-col>
      <v-col cols="12" v-else-if="display === 2">
        <game-edit-view
            v-if="!shouldHideEditGame"
            :displayView="displayView"
            :key="editKey"
            @updateIframe="renderEditGame"
            single="single"
            class="box no-gutters"
        />
        <div v-else>
          {{$t('pages.createGame.cannotEditGameMobile')}}
        </div>
      </v-col>
      <v-col v-else cols="12">
        <row no-gutters>
          <v-col cols="12" lg="6" class="mb-3">
            <game-preview-view
                :displayView="displayView"
                :index="gameViewKey"
                :key="gameViewKey"
                single=""
                class="box no-gutters"
            />
          </v-col>
          <v-col cols="12" lg="6" class="mb-3">
            <game-edit-view
                v-if="!shouldHideEditGame"
                :displayView="displayView"
                :key="editKey"
                @updateIframe="renderEditGame"
                @jsonChanged="renderGameView"
                single=""
                class="box no-gutters"
            />
            <div v-else>
              {{$t('pages.createGame.cannotEditGameMobile')}}
            </div>
          </v-col>
        </row>
      </v-col>
    </row>
  </page>
</template>

<script>
import { types, types as GameTypes } from "../../store/modules/Game.module";
import GamePreviewView from "src/view/games/GamePreviewView";
import GameEditView from "src/view/games/GameEditView";
import GameDisplaySelect from "src/view/games/GameDisplaySelect";
import GameScreenSelect from "src/view/games/GameScreenSelect";

export default {
  name: "game-view",
  props: [],
  components: {
    GameEditView,
    GamePreviewView,
    GameDisplaySelect,
    GameScreenSelect
  },
  data() {
    return {
      editKey: 0,
      gameViewKey: 0,
      inProgress: true,
      showGameModes: false,

    };
  },
  computed: {
    game() {
      return this.$store.getters.game;
    },
    display() {
      if (this.$route.query.onlyEdit == 1)
        return 2;
      return this.$store.getters.gameDisplay;
    },
    displayView() {
      return this.$store.getters.displayView;
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    shouldHideEditGame() {
      // Hide the edit game button if the user is on mobile and the game type is educational because of upload image prevent)
      return this.isMobile && this.$store.state.AuthModule.user?.is_edu;
    },
  },
  methods: {
    renderEditGame() {
      this.editKey += 1;
    },
    renderGameView() {
      this.gameViewKey += 1;
    },
    displayChanged(display) {
      this.showGameModes = false;
      this.$store.commit(types.DISPLAY, display);
    },
    screenChanged(value) {
      this.showGameModes = false;
      this.$store.commit(types.DISPLAY_VIEW, value);
    },
  },
  async created() {
    const id = this.$route.params.id;
    if (id && id != this.game.id) {
      await this.$store.dispatch(GameTypes.GET, id);
    }
    if (this.game) {
      this.inProgress = false;
    }

  },

  destroyed() {
    localStorage.display = this.display;
  }
};
</script>

<style scoped>
.top-bar {
  border-bottom: solid 3px black;
  width: 100%;
}
.icon-wrapper {
  background-color: white;
  gap: 12px;
}

#inspire > div > div > main > div > div {
  padding: 10px;
}

.box {
  /* background-color: hsla(0,0%,100%,.5); */
  border-radius: 20px;
  margin: 0 20px !important;
  overflow: hidden;
  /* box-shadow: 0px 0px 9px 7px rgba(0,0,0,0.18); */
}
</style>
